// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__wU7E6","footer":"ModalError_footer__26t4y"};